import { oc } from '@orpc/contract';
import { getImportBatchInputSchema, importBatchDetailSchema } from '../schemas/import.schemas.js';
export const getImportBatchContract = oc
    .route({
    method: 'GET',
    path: '/import/batches/{id}',
    tags: ['Import'],
    summary: 'One import batch with the per-row error report it recorded',
})
    .input(getImportBatchInputSchema)
    .output(importBatchDetailSchema);
//# sourceMappingURL=get-import-batch.contract.js.map